import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { useEffect } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import ThirdpartyRisks from '../../../../containers/thirdparties/thirdparty-sheet/ThirdpartyRisks';
import EATabPanel from '../../../common/EATabPanel';
import { isNull, isEmpty } from 'lodash';

function RiskSection({ display, title, risks, thirdPartyId, contacts, isUnmanaged, onRiskChange, isExpanded}) {
  const { classes } = useStyles();
  const [isExpandedRisk, setExpandedRisk] = React.useState(isExpanded);

  // Ouvre le panel si au moins un score de risque contient des données
  useEffect(() => {
    if (!risks) {
      setExpandedRisk(false);
      return;
    }

    const hasValidRisk = Object.entries(risks).some(([type, data]) => {
      if (!data) return false;

      switch (type) {
        case 'indued':
          return !!(data.created_date && data.due_diligence);
        case 'transparency':
        case 'datablocks_financial_strength':
        case 'owlin':
        case 'datablocks_esg':
          return !isEmpty(data);
        case 'ecovadis':
        case 'security_rating':
        case 'credit_safe':
        default:
          return !Object.values(data).every(isNull);
      }
    });

    setExpandedRisk(hasValidRisk);
  }, [risks])

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"risk"}>
      <EAAccordion
        title={title}
        logo="thirdparty/risk"
        titleNoResult
        opened={isExpandedRisk}
      >
        <EATabPanel
          key={0}
          value={0}
          index={0}
          variant="tpCustom"
          shadow
        >
          <ThirdpartyRisks
            risks={risks}
            onRiskChange={onRiskChange}
            thirdPartyId={thirdPartyId}
            contacts={contacts}
            isUnmanaged={isUnmanaged}
          />
        </EATabPanel>
      </EAAccordion>
    </Grid>
  );
}

export default RiskSection;
